// extracted by mini-css-extract-plugin
module.exports = {"content":"NextEvent_content__36vxO","icon":"NextEvent_icon__--4bG","button":"NextEvent_button__3mMSv","headings":"NextEvent_headings__2DZPk"};